import * as _ from 'lodash';

import { ObjectAccessRights, AccessRights } from '../../models';

export interface IAccessRightsHelper {
    isDashboardAccessible(dashboardGuid: string, categoriesGuid: string[], userGuid: string, userRoles: string[], allAccessRights: ObjectAccessRights[]): boolean;
    isCategoryAccessible(categoryGuid: string, userGuid: string, userRoles: string[], allAccessRights: ObjectAccessRights[]): boolean;
}

export class AccessRightsHelper implements IAccessRightsHelper {
    static serviceId = 'accessRightsHelper';

    static $inject = [];

    isDashboardAccessible(dashboardGuid: string, categoriesGuid: string[], userGuid: string, userRoles: string[], allAccessRights: ObjectAccessRights[]): boolean {
        let isAccessible: boolean = this.isItemAccessible(dashboardGuid, userGuid, userRoles, allAccessRights);
        // Get all categories linked to dashboard, if at least one is accessible, dashboard is accessible by its categories
        if (isAccessible) {
            categoriesGuid.forEach(categoryGuid => {
                if (isAccessible) {
                    isAccessible = this.isCategoryAccessible(categoryGuid, userGuid, userRoles, allAccessRights);
                }
            });
        }
        return isAccessible;
    }

    isCategoryAccessible(categoryGuid: string, userGuid: string, userRoles: string[], allAccessRights: ObjectAccessRights[]): boolean {
        return this.isItemAccessible(categoryGuid, userGuid, userRoles, allAccessRights);
    }

    private isItemAccessible(itemGuid: string, userGuid: string, userRoles: string[], allAccessRights: ObjectAccessRights[]) {
        let userAllowed: boolean = true;
        let roleAllowed: boolean = true;
        const itemAccessRights = this.getAccessRightsForItem(itemGuid, allAccessRights);
        if (itemAccessRights) {
            if (itemAccessRights.userCollection && itemAccessRights.userCollection.length > 0) {
                const foundUser = _.find(itemAccessRights.userCollection, user => user === userGuid);
                userAllowed = !!foundUser;
            }
            if (itemAccessRights.roleCollection && itemAccessRights.roleCollection.length > 0 && userAllowed) {
                roleAllowed = _.some(itemAccessRights.roleCollection, r => userRoles.indexOf(r) > -1);
            }
        }
        return userAllowed && roleAllowed;
    }

    private getAccessRightsForItem(itemGuid: string, allAccessRights: ObjectAccessRights[]): AccessRights {
        const found = _.find(allAccessRights, ac => ac.guid === itemGuid);
        return found ? found.accessRights : undefined;
    }
}